module.exports = __webpack_public_path__ + "media/luxury-2026/waterfront-drone-7bca376a.jpg";